"use client";
import { Tooltip } from "react-tooltip";

export const TooltipWrapper = ({ anchorSelect, children }) => {
  return <Tooltip anchorSelect={anchorSelect}>{children}</Tooltip>;
};
